import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class FetchGiftDeliveryDates {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    handle() {
        let apiUrl = ApiEndpoints['gifting.delivery-dates'];

        return this.apiService.get(apiUrl);
    }
}
